import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AddressSocialDetail from 'src/Components/AddressSocialDetail';
import CustomerVerification from 'src/Components/AdminComponents/UserEditByAdmin/CustomerVerification';
import UserAccountDetails from 'src/Components/AdminComponents/UserEditByAdmin/UserAccountDetails';
import HealthSystem from 'src/Components/Customer/HealthSystem';
import ProfileUserDetailDashboard from 'src/Components/Customer/ProfileUserDetailDashboard';
import RecentTest from 'src/Components/Customer/RecentTest';
import BreadCrumb from 'src/Components/GlobalComponents/BreadCrumb';
import SplashScreen from 'src/Components/SplashScreen';
import httpRequest from 'src/helpers/httpRequest';
import { IProfileData } from 'src/types/GlobalInterfaces';

type tabTypes = "Profile" | "Account Details" | "Customer Verification";

const ViewCustomerProfile: React.FC = () => {
    const tabList: tabTypes[] = ["Profile", "Account Details"];
    // const tabList: tabTypes[] = ["Profile", "Account Details"];
    // const tabList: tabTypes[] = ["Profile", "Account Details", "Customer Verification"];
    const [activeTab, setActiveTab] = useState<tabTypes>("Profile");
    const navigate = useNavigate();
    const { uid = "" } = useParams();
    const [profileData, setProfileData] = useState<IProfileData>({});
    const changeTab = (newTab: tabTypes) => {
        setActiveTab(newTab);
        if (newTab === "Customer Verification") {
            setProfileData(prev => ({
                ...prev,
                unReadNotified: false,
            }));
        }
    };

    /**
    * Fetch profile data from the API.
    * 
    * @param uid - The user ID to fetch the profile data.
    */
    const [getLoader, setgetLoader] = useState<boolean>(false);
    const fetchProfileData = async (_id: string) => {
        setgetLoader(true);
        const { res, err } = await httpRequest<IProfileData>({ path: `/customer/get/profile/${_id}?status=admin` });
        if (res) {
            setProfileData(res);
        } else {
            toast(err, { type: 'error' });
        }
        setgetLoader(false);
    };

    useEffect(() => {
        fetchProfileData(uid); // Fetch profile data when component mounts
    }, [uid]);
    return (
        <>
            {getLoader && <SplashScreen />}
            <BreadCrumb
                current="Profile"
                previous="dashboard"
                navigateUrl="/admin"
                btnShow={true}
                isUpsert={true}
                onPress={() => navigate("/customers")}
            />
            <div className="table-container">
                {/* <div className='products-tabs-btn md:col-span-2 col-span-1'>
                    {tabList.map((v: tabTypes) => (
                        <button
                            key={v}
                            className={`font-size-15px font-Poppins-Medium relative ${activeTab === v && 'active'}`}
                            onClick={() => changeTab(v)}
                        >{v}
                            {(!profileData?.customerVerificationNotified && v === "Customer Verification") ?
                                <div className="red-dot-show-only-dot absolute -top-1 -right-1">

                                </div>
                                : null}
                        </button>
                    ))}
                </div> */}
                {/* <hr className='products-tabs-hr-allOrder' /> */}
                {activeTab === "Profile"
                    ?
                    <div className="container-1480 h-3vw block justify-between h-3vw md:flex lg:flex">
                        <div className="w-full md:w-3/4 lg:w-3/4">
                            <ProfileUserDetailDashboard
                                data={profileData}
                                setData={setProfileData}
                                isAdmin={true}
                            />
                            <HealthSystem
                                id={uid}
                            />
                            <RecentTest
                                id={uid}
                            />
                        </div>
                        <div className="w-1/4 pl-2 show-location-detail-mob">
                            <AddressSocialDetail
                                data={profileData}
                            />
                        </div>
                    </div>
                    // : activeTab === "Account Details" ?
                    //     <UserAccountDetails
                    //         userId={uid}
                    //     />
                        :
                        // <CustomerVerification
                        //     userId={uid}
                        // />
                        null
                }
            </div>
        </>
    );
};

export default ViewCustomerProfile;